import ShelfEventsDataViewer from './ShelfEventsDataViewer'
import ShelfQueryHandler from './ShelfQueryHandler'
import ShelfSupportDataViewer from './ShelfSupportDataViewer'
import EditShelfCardSettingsAction from './actions/EditShelfCardSettingsAction'
import DetailSetup from './detail/PluginSetup'

export default {
  install( molten ) {
    molten.addPlugin( 'Action', EditShelfCardSettingsAction )

    molten.addPlugin( 'DataViewer', ShelfSupportDataViewer )
    molten.addPlugin( 'DataViewer', ShelfEventsDataViewer )
    molten.addPlugin( 'EventQueryOptionsHandler', ShelfQueryHandler )

    DetailSetup.install( molten )
  },
}
